import { getCreditCardNumberPreview, getCreditCardType } from 'shared/utils'
import Button from '@components/Button'
import DeleteButton from '@components/DeleteButton'
import Icon from '@components/Icon'
import CircleLoader from '@components/CircleLoader'

const ListItem = ({ default: isDefault, nickName, cardLast4, cardType, onDelete, setDefault, expDate, pending }) => (
    <li className="d-flex">
        <Icon type={getCreditCardType(cardType)} className="mr-3" size="sm" withShadow />
        <span className="title mr-2">{getCreditCardNumberPreview({ nickName, cardLast4, expDate })}</span>
        {pending ? (
            <CircleLoader className="ml-2" size="small" />
        ) : (
            <>
                {isDefault ? (
                    <span className="default-card mr-2">
                        (<T>six.cards.creditcard.default</T>)
                    </span>
                ) : (
                    <Button btnStyle="link" className="toggleVisible mr-2" size="small" onClick={setDefault}>
                        <T>six.cards.creditcard.set.default</T>
                    </Button>
                )}
                <DeleteButton onClick={onDelete} />
            </>
        )}
    </li>
)

export default ListItem
